// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.paragraph-body {
font-size: 16px;
font-weight: 300;
color: #545454;
}


.title-body {
    font-size: 20px;
    font-weight: 600;
    color: #545454;
    }

    .title-body-general {
    font-size: 28px;
    color: #545454;
    }
    .title-pub {
        font-size: 20px;
        font-weight: 400;
        color: #116AAB;
        }


    .title-year-body {
        font-size: 14px;
        font-weight: 400;
        color: #545454;
        }


    .title-body-no-bold {
        font-size: 20px;
        font-weight: 200;
        color: #545454;
        }
    

.table-grey-column-bold-text {
   color: #545454;
font-size: 16px;
font-style: normal;
font-weight: 600;
line-height: 24px; 
    }


    .table-target-title-bold-text {
   color: #545454;
font-size: 18px;
font-style: normal;
font-weight: 600;
line-height: 24px; 
    }


.table-target-title-non-bold-text {
color: #545454;
font-size: 16px;
font-style: normal;
font-weight: 300;
line-height: 24px; 
 }

.table-para{
    margin-left: 50px !important;
    padding-right: 1rem;
    padding-top: 1rem;
}


.table-grey-column-non-bold-text {
color: #545454;
font-size: 16px;
font-style: normal;
font-weight: 300;
line-height: 24px; 
 }


         
.wrapper {
overflow: auto;
border-radius: 6px;
border: 0.5px solid rgb(187, 186, 186) ; 
}

.wrapper-side-borders {
overflow: auto;
border-radius: 6px;
border-left: 0.1px solid rgb(187, 186, 186) !important; 
border-right: 0.1px solid rgb(187, 186, 186) !important; 

}



.borders-table {
border-left: 0.5px solid rgb(187, 186, 186);
border-right: 0.5px solid rgb(187, 186, 186);
}

.country-profile-page {
   text-align: center;
              }
            
.alphabet-letter {
    color: #545454;

font-size: 2.5rem;
font-style: normal;
font-weight: 600;
line-height: 2.5rem;
}

.country-name {
    color: #116AAB;
font-size: 1rem;
text-decoration: none;

font-style: normal;
font-weight: 400;
line-height: 2rem;
}
        
.profiles-country-box {
    column-width: 250px;
 /*  width: 80%; */
  /*  margin-left: 160px; */
 margin-top: 10px;
margin-bottom: 25px;
}
    
.profiles-organisations-box {
  column-width: 400px;
/*  width: 80%; */
/*  margin-left: 160px; */
margin-top: 10px;
margin-bottom: 25px;
}

.data-button {
    color: #545454;
font-size: 1rem;
font-style: normal;
font-weight: 400;
line-height: normal;
margin-bottom: 0%;
}

.button-is-not-active {
    border-radius: 0.25rem !important;
    border: 1px solid rgba(0, 0, 0, 0.10) !important;
    background: #FFF !important;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.15) !important;
}

.button-is-active {
    border-radius: 0.25rem !important;
    border: 1px solid var(--Primary, #116AAB) !important;
    background: #FFF !important;
    color: #116AAB;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.15) !important;
}

.button-is-active  h1{
    color: #116AAB;
}


.country-table-header {
color: var(--Gray-Dark, #545454);
font-size: 0.8rem;
font-style: normal;
font-weight: 400;
text-align: center;
line-height: 1.05rem; /* 140% */
}

.country-table-text {
    color: var(--Gray-Dark, #545454);

    font-size: 0.875rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1.25rem; /* 142.857% */
    letter-spacing: 0.01563rem;
    }

.legend-element {
    margin-right: 0.9rem;
    margin-left: 0.1rem;
   
    
}
        
         
.target-legend-element {
    color: var(--Gray-Dark, #545454);
font-size: 1.25rem;
font-style: normal;
font-weight: 480;
line-height: 1.05rem; /* 84% */
}

.target-indicator-title {
    color: var(--Gray-Dark, rgb(130, 128, 128));
font-size: 0.75rem;
font-style: normal;
font-weight: 600;
line-height: 1.05rem;
}

.target-indicator-summary-title {
  color: var(--Gray-Dark, #545454);
font-size: 0.85rem;
font-style: normal;
font-weight: 500;
line-height: 1.05rem;
}

.target-indicator-country-total-title {
  color: var( #232323);
font-size: 0.95rem;
font-style: normal;
font-weight: 500;
line-height: 1.05rem;
}


.target-indicator-text {
    color: var(--Gray-Dark, #545454);
    font-size: 0.8rem;
    font-style: normal;
    font-weight: 300;
    line-height: 1.25rem; /* 142.857% */
    letter-spacing: 0.01563rem;
}

.year-table-cell {
  padding-top: 0.4rem;
}

.tableau-frame{
    width: 1040px;
    height:991px;
}

.work-activities-text {
    
    color: var(--Gray-Dark, #545454);
    margin: 0px;
font-size: 0.775rem;
font-style: normal;
font-weight: 300;
line-height: 1.25rem; /* 142.857% */
letter-spacing: 0.01563rem;
}
.sub-heading {
   transform: rotate(-45deg); 
    color: var(--Gray-Dark, #545454);
font-size: 0.8rem;
font-style: normal;
font-weight: 400;
text-align: center;

}

.new-sub-heading {
 
   color: var(--Gray-Dark, #545454);
font-size: 0.8rem;
font-style: normal;
font-weight: 600;
text-align: center;

}


.species-table-color-one {
    background-color: #B9DDF1;
    height: 200px;
  
}

.species-table-color-two {
    background-color: #BCE4D8;
    height: 200px;
}

.species-table-color-three {
    background-color: #D5E8AF;
    height: 200px;
    text-align: center;
}

.species-table-color-four {
    background-color: #B3E0A6;
    height: 200px;
   
}


.top-header-color-one {
    background-color: #B9DDF1;
    border-bottom: 1px solid #ddd;

   
  
}

.top-header-color-two {
    background-color: #BCE4D8;
    border-bottom: 1px solid #ddd;
}

.top-header-color-three {
    background-color: #D5E8AF;
    border-bottom: 1px solid #ddd;

}

.top-header-color-four {
    background-color: #B3E0A6;
    border-bottom: 1px solid #ddd;
  
}

.genericTable thead tr th:nth-child(1),
.genericTable tbody tr td:nth-child(1){
    position: sticky;
    position: -webkit-sticky;
    background-color: red;
    left:0;
    z-index:2;
}



  .table {
    /* border: 1px solid #ddd; */
    width: fit-content;
    /* overflow: scroll;
    max-width: 100%; */

    .tr {
      :last-child {
        .td {
          border-bottom: 0;
        }
      }
    }

 




   .species-table-color-one
    p {
      
      margin-top: 80px;
     transform: rotate(-45deg);  
   }

   .species-table-color-two
   p {
     
     margin-top: 80px;
    transform: rotate(-45deg);  
  }

  .species-table-color-three
  p {
    
  margin-top: 80px;
   transform: rotate(-45deg);  
 }

 .species-table-color-four
 p {
   
   margin-top: 60px;
   margin-left: 0px;
   
  transform: rotate(-45deg);  
}

.larger, .grey-color, .top-header-grey {
    background-color: #F7F8F9;
 
   
}
.small-font p{
    font-size: 12px;
    padding-top: 2px;
}
.larger, .grey-color, .top-header-grey {
min-width: 250px;
}

.small-grey-color {
    background-color: #F7F8F9;
    margin-bottom: 1px solid #ddd;

}



 .rowsData{
    max-height: 50px;
    
    }

.top-header-grey, 
.top-header-color-one, 
.top-header-color-two, 
.top-header-color-three, 
.top-header-color-four {
    max-height: 200px;
    padding: 5px;
}

.top-header-grey, 
.top-header-color-one, 
.top-header-color-two, .top-header-color-three, .top-header-color-four p{
     margin-top: 0px; 
}

 .bottom-line {
    border-bottom: 1px solid #ddd;

} 



 .limit-size{
    max-width: 130px !important;
} 
    .td {
      
       /* border-right: 1px solid #ddd;   */
      overflow: hidden;  


  


      .last-element{
        border-right: 1px solid #ddd;
    }
       .resizer {
        display: inline-block;
        width: 5px;
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
        transform: translateX(50%);
        z-index: 1;

        &.isResizing {
          background: red;
        }
      }
    } 

     &.sticky {
      /* overflow: scroll; */
      .header,
      .footer {
        position: sticky;
        z-index: 1;
        width: fit-content;
      } 

      .header {
        z-index: 4;
        top: 0;
        box-shadow: 0px 3px 3px #ccc;
      }


      .body {
      }

      [data-sticky-td] {
        position: sticky;
      }

      [data-sticky-last-left-td] {
        box-shadow: 2px 0px 3px #ccc;
      }

      [data-sticky-first-right-td] {
        box-shadow: -2px 0px 3px #ccc;
      }
    }
  }

  .country-details{

    color: #116AAB;
    font-size: 1rem;
font-style: normal;
font-weight: 400;

  }


  .country-title{

  
    font-size: 1rem;
font-style: normal;
font-weight: 700;

  }

  .csv-button {
  
    width: 4.6875rem;
    height: 2rem;
    flex-shrink: 0;
    border-radius: 0.1875rem;
    background: var(--Primary, #116AAB);
 }

 .card-title {
         font-weight: 500;
  }

    @media screen and (min-width: 1000px) {
  .graph-div-main {
   min-height: 30rem;
  }

   .graph-div-subquestion {
   height: 15rem;
  }

  

}

.container-header {
    position: relative;
    height: 4rem
  }


  .big-container-header {
    position: relative;
    height: 6rem
  }
  .vertical-center {
  margin: 0 !important;
  position: absolute !important;
  top: 50% !important;
  transform: translateY(-50%)!important;
 
}

 @media screen and (max-width: 1200px) {
 .card-padding {
  margin-top: 1rem;
 }
 }

  .card-padding-always {
  margin-top: 2rem;
 }


 @media screen and (max-width: 600px) {
 .graph-height-mobile {
  height: 400px !important;
 }
 }

  @media screen and (max-width: 900px) {
     .col-sm-12 {
  margin-top:10px !important ;
 }

     .col-xs-12 {
  margin-top:10px !important;
 }
 }

 .full-height {
  height: 100%;
  width: 100%;
 }

  @media screen and (min-width: 600px) {
 .mobile-legend {
  display: none;
 }
}`, "",{"version":3,"sources":["webpack://./src/styles/pages.css"],"names":[],"mappings":"AAAA;AACA,eAAe;AACf,gBAAgB;AAChB,cAAc;AACd;;;AAGA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd;;IAEA;IACA,eAAe;IACf,cAAc;IACd;IACA;QACI,eAAe;QACf,gBAAgB;QAChB,cAAc;QACd;;;IAGJ;QACI,eAAe;QACf,gBAAgB;QAChB,cAAc;QACd;;;IAGJ;QACI,eAAe;QACf,gBAAgB;QAChB,cAAc;QACd;;;AAGR;GACG,cAAc;AACjB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB;IACb;;;IAGA;GACD,cAAc;AACjB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB;IACb;;;AAGJ;AACA,cAAc;AACd,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB;CAChB;;AAED;IACI,4BAA4B;IAC5B,mBAAmB;IACnB,iBAAiB;AACrB;;;AAGA;AACA,cAAc;AACd,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB;CAChB;;;;AAID;AACA,cAAc;AACd,kBAAkB;AAClB,uCAAuC;AACvC;;AAEA;AACA,cAAc;AACd,kBAAkB;AAClB,sDAAsD;AACtD,uDAAuD;;AAEvD;;;;AAIA;AACA,2CAA2C;AAC3C,4CAA4C;AAC5C;;AAEA;GACG,kBAAkB;cACP;;AAEd;IACI,cAAc;;AAElB,iBAAiB;AACjB,kBAAkB;AAClB,gBAAgB;AAChB,mBAAmB;AACnB;;AAEA;IACI,cAAc;AAClB,eAAe;AACf,qBAAqB;;AAErB,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB;AACjB;;AAEA;IACI,mBAAmB;CACtB,iBAAiB;EAChB,yBAAyB;CAC1B,gBAAgB;AACjB,mBAAmB;AACnB;;AAEA;EACE,mBAAmB;AACrB,iBAAiB;AACjB,yBAAyB;AACzB,gBAAgB;AAChB,mBAAmB;AACnB;;AAEA;IACI,cAAc;AAClB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,mBAAmB;AACnB,iBAAiB;AACjB;;AAEA;IACI,iCAAiC;IACjC,gDAAgD;IAChD,2BAA2B;IAC3B,0DAA0D;AAC9D;;AAEA;IACI,iCAAiC;IACjC,oDAAoD;IACpD,2BAA2B;IAC3B,cAAc;IACd,0DAA0D;AAC9D;;AAEA;IACI,cAAc;AAClB;;;AAGA;AACA,gCAAgC;AAChC,iBAAiB;AACjB,kBAAkB;AAClB,gBAAgB;AAChB,kBAAkB;AAClB,oBAAoB,EAAE,SAAS;AAC/B;;AAEA;IACI,gCAAgC;;IAEhC,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB,EAAE,aAAa;IACnC,0BAA0B;IAC1B;;AAEJ;IACI,oBAAoB;IACpB,mBAAmB;;;AAGvB;;;AAGA;IACI,gCAAgC;AACpC,kBAAkB;AAClB,kBAAkB;AAClB,gBAAgB;AAChB,oBAAoB,EAAE,QAAQ;AAC9B;;AAEA;IACI,2CAA2C;AAC/C,kBAAkB;AAClB,kBAAkB;AAClB,gBAAgB;AAChB,oBAAoB;AACpB;;AAEA;EACE,gCAAgC;AAClC,kBAAkB;AAClB,kBAAkB;AAClB,gBAAgB;AAChB,oBAAoB;AACpB;;AAEA;EACE,oBAAoB;AACtB,kBAAkB;AAClB,kBAAkB;AAClB,gBAAgB;AAChB,oBAAoB;AACpB;;;AAGA;IACI,gCAAgC;IAChC,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB,EAAE,aAAa;IACnC,0BAA0B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;;IAEI,gCAAgC;IAChC,WAAW;AACf,mBAAmB;AACnB,kBAAkB;AAClB,gBAAgB;AAChB,oBAAoB,EAAE,aAAa;AACnC,0BAA0B;AAC1B;AACA;GACG,yBAAyB;IACxB,gCAAgC;AACpC,iBAAiB;AACjB,kBAAkB;AAClB,gBAAgB;AAChB,kBAAkB;;AAElB;;AAEA;;GAEG,gCAAgC;AACnC,iBAAiB;AACjB,kBAAkB;AAClB,gBAAgB;AAChB,kBAAkB;;AAElB;;;AAGA;IACI,yBAAyB;IACzB,aAAa;;AAEjB;;AAEA;IACI,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,aAAa;;AAEjB;;;AAGA;IACI,yBAAyB;IACzB,6BAA6B;;;;AAIjC;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;;AAEjC;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;;AAEjC;;AAEA;;IAEI,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,MAAM;IACN,SAAS;AACb;;;;EAIE;IACE,4BAA4B;IAC5B,kBAAkB;IAClB;sBACkB;;IAElB;MACE;QACE;UACE,gBAAgB;QAClB;MACF;IACF;;;;;;;GAOD;;;MAGG,gBAAgB;KACjB,yBAAyB;GAC3B;;GAEA;;;KAGE,gBAAgB;IACjB,yBAAyB;EAC3B;;EAEA;;;EAGA,gBAAgB;GACf,yBAAyB;CAC3B;;CAEA;;;GAGE,gBAAgB;GAChB,gBAAgB;;EAEjB,yBAAyB;AAC3B;;AAEA;IACI,yBAAyB;;;AAG7B;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;AACA,gBAAgB;AAChB;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;;AAEjC;;;;CAIC;IACG,gBAAgB;;IAEhB;;AAEJ;;;;;IAKI,iBAAiB;IACjB,YAAY;AAChB;;AAEA;;;KAGK,eAAe;AACpB;;CAEC;IACG,6BAA6B;;AAEjC;;;;CAIC;IACG,2BAA2B;AAC/B;IACI;;OAEG,oCAAoC;MACrC,gBAAgB;;;;;;MAMhB;QACE,4BAA4B;IAChC;OACG;QACC,qBAAqB;QACrB,UAAU;QACV,YAAY;QACZ,kBAAkB;QAClB,QAAQ;QACR,MAAM;QACN,0BAA0B;QAC1B,UAAU;;QAEV;UACE,eAAe;QACjB;MACF;IACF;;KAEC;MACC,sBAAsB;MACtB;;QAEE,gBAAgB;QAChB,UAAU;QACV,kBAAkB;MACpB;;MAEA;QACE,UAAU;QACV,MAAM;QACN,4BAA4B;MAC9B;;;MAGA;MACA;;MAEA;QACE,gBAAgB;MAClB;;MAEA;QACE,4BAA4B;MAC9B;;MAEA;QACE,6BAA6B;MAC/B;IACF;EACF;;EAEA;;IAEE,cAAc;IACd,eAAe;AACnB,kBAAkB;AAClB,gBAAgB;;EAEd;;;EAGA;;;IAGE,eAAe;AACnB,kBAAkB;AAClB,gBAAgB;;EAEd;;EAEA;;IAEE,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,wBAAwB;IACxB,mCAAmC;CACtC;;CAEA;SACQ,gBAAgB;EACvB;;IAEE;EACF;GACC,iBAAiB;EAClB;;GAEC;GACA,aAAa;EACd;;;;AAIF;;AAEA;IACI,kBAAkB;IAClB;EACF;;;EAGA;IACE,kBAAkB;IAClB;EACF;EACA;EACA,oBAAoB;EACpB,6BAA6B;EAC7B,mBAAmB;EAEnB,qCAAqC;;AAEvC;;CAEC;CACA;EACC,gBAAgB;CACjB;CACA;;EAEC;EACA,gBAAgB;CACjB;;;CAGA;CACA;EACC,wBAAwB;CACzB;CACA;;EAEC;KACG;EACH,2BAA2B;CAC5B;;KAEI;EACH,0BAA0B;CAC3B;CACA;;CAEA;EACC,YAAY;EACZ,WAAW;CACZ;;EAEC;CACD;EACC,aAAa;CACd;AACD","sourcesContent":[".paragraph-body {\nfont-size: 16px;\nfont-weight: 300;\ncolor: #545454;\n}\n\n\n.title-body {\n    font-size: 20px;\n    font-weight: 600;\n    color: #545454;\n    }\n\n    .title-body-general {\n    font-size: 28px;\n    color: #545454;\n    }\n    .title-pub {\n        font-size: 20px;\n        font-weight: 400;\n        color: #116AAB;\n        }\n\n\n    .title-year-body {\n        font-size: 14px;\n        font-weight: 400;\n        color: #545454;\n        }\n\n\n    .title-body-no-bold {\n        font-size: 20px;\n        font-weight: 200;\n        color: #545454;\n        }\n    \n\n.table-grey-column-bold-text {\n   color: #545454;\nfont-size: 16px;\nfont-style: normal;\nfont-weight: 600;\nline-height: 24px; \n    }\n\n\n    .table-target-title-bold-text {\n   color: #545454;\nfont-size: 18px;\nfont-style: normal;\nfont-weight: 600;\nline-height: 24px; \n    }\n\n\n.table-target-title-non-bold-text {\ncolor: #545454;\nfont-size: 16px;\nfont-style: normal;\nfont-weight: 300;\nline-height: 24px; \n }\n\n.table-para{\n    margin-left: 50px !important;\n    padding-right: 1rem;\n    padding-top: 1rem;\n}\n\n\n.table-grey-column-non-bold-text {\ncolor: #545454;\nfont-size: 16px;\nfont-style: normal;\nfont-weight: 300;\nline-height: 24px; \n }\n\n\n         \n.wrapper {\noverflow: auto;\nborder-radius: 6px;\nborder: 0.5px solid rgb(187, 186, 186) ; \n}\n\n.wrapper-side-borders {\noverflow: auto;\nborder-radius: 6px;\nborder-left: 0.1px solid rgb(187, 186, 186) !important; \nborder-right: 0.1px solid rgb(187, 186, 186) !important; \n\n}\n\n\n\n.borders-table {\nborder-left: 0.5px solid rgb(187, 186, 186);\nborder-right: 0.5px solid rgb(187, 186, 186);\n}\n\n.country-profile-page {\n   text-align: center;\n              }\n            \n.alphabet-letter {\n    color: #545454;\n\nfont-size: 2.5rem;\nfont-style: normal;\nfont-weight: 600;\nline-height: 2.5rem;\n}\n\n.country-name {\n    color: #116AAB;\nfont-size: 1rem;\ntext-decoration: none;\n\nfont-style: normal;\nfont-weight: 400;\nline-height: 2rem;\n}\n        \n.profiles-country-box {\n    column-width: 250px;\n /*  width: 80%; */\n  /*  margin-left: 160px; */\n margin-top: 10px;\nmargin-bottom: 25px;\n}\n    \n.profiles-organisations-box {\n  column-width: 400px;\n/*  width: 80%; */\n/*  margin-left: 160px; */\nmargin-top: 10px;\nmargin-bottom: 25px;\n}\n\n.data-button {\n    color: #545454;\nfont-size: 1rem;\nfont-style: normal;\nfont-weight: 400;\nline-height: normal;\nmargin-bottom: 0%;\n}\n\n.button-is-not-active {\n    border-radius: 0.25rem !important;\n    border: 1px solid rgba(0, 0, 0, 0.10) !important;\n    background: #FFF !important;\n    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.15) !important;\n}\n\n.button-is-active {\n    border-radius: 0.25rem !important;\n    border: 1px solid var(--Primary, #116AAB) !important;\n    background: #FFF !important;\n    color: #116AAB;\n    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.15) !important;\n}\n\n.button-is-active  h1{\n    color: #116AAB;\n}\n\n\n.country-table-header {\ncolor: var(--Gray-Dark, #545454);\nfont-size: 0.8rem;\nfont-style: normal;\nfont-weight: 400;\ntext-align: center;\nline-height: 1.05rem; /* 140% */\n}\n\n.country-table-text {\n    color: var(--Gray-Dark, #545454);\n\n    font-size: 0.875rem;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 1.25rem; /* 142.857% */\n    letter-spacing: 0.01563rem;\n    }\n\n.legend-element {\n    margin-right: 0.9rem;\n    margin-left: 0.1rem;\n   \n    \n}\n        \n         \n.target-legend-element {\n    color: var(--Gray-Dark, #545454);\nfont-size: 1.25rem;\nfont-style: normal;\nfont-weight: 480;\nline-height: 1.05rem; /* 84% */\n}\n\n.target-indicator-title {\n    color: var(--Gray-Dark, rgb(130, 128, 128));\nfont-size: 0.75rem;\nfont-style: normal;\nfont-weight: 600;\nline-height: 1.05rem;\n}\n\n.target-indicator-summary-title {\n  color: var(--Gray-Dark, #545454);\nfont-size: 0.85rem;\nfont-style: normal;\nfont-weight: 500;\nline-height: 1.05rem;\n}\n\n.target-indicator-country-total-title {\n  color: var( #232323);\nfont-size: 0.95rem;\nfont-style: normal;\nfont-weight: 500;\nline-height: 1.05rem;\n}\n\n\n.target-indicator-text {\n    color: var(--Gray-Dark, #545454);\n    font-size: 0.8rem;\n    font-style: normal;\n    font-weight: 300;\n    line-height: 1.25rem; /* 142.857% */\n    letter-spacing: 0.01563rem;\n}\n\n.year-table-cell {\n  padding-top: 0.4rem;\n}\n\n.tableau-frame{\n    width: 1040px;\n    height:991px;\n}\n\n.work-activities-text {\n    \n    color: var(--Gray-Dark, #545454);\n    margin: 0px;\nfont-size: 0.775rem;\nfont-style: normal;\nfont-weight: 300;\nline-height: 1.25rem; /* 142.857% */\nletter-spacing: 0.01563rem;\n}\n.sub-heading {\n   transform: rotate(-45deg); \n    color: var(--Gray-Dark, #545454);\nfont-size: 0.8rem;\nfont-style: normal;\nfont-weight: 400;\ntext-align: center;\n\n}\n\n.new-sub-heading {\n \n   color: var(--Gray-Dark, #545454);\nfont-size: 0.8rem;\nfont-style: normal;\nfont-weight: 600;\ntext-align: center;\n\n}\n\n\n.species-table-color-one {\n    background-color: #B9DDF1;\n    height: 200px;\n  \n}\n\n.species-table-color-two {\n    background-color: #BCE4D8;\n    height: 200px;\n}\n\n.species-table-color-three {\n    background-color: #D5E8AF;\n    height: 200px;\n    text-align: center;\n}\n\n.species-table-color-four {\n    background-color: #B3E0A6;\n    height: 200px;\n   \n}\n\n\n.top-header-color-one {\n    background-color: #B9DDF1;\n    border-bottom: 1px solid #ddd;\n\n   \n  \n}\n\n.top-header-color-two {\n    background-color: #BCE4D8;\n    border-bottom: 1px solid #ddd;\n}\n\n.top-header-color-three {\n    background-color: #D5E8AF;\n    border-bottom: 1px solid #ddd;\n\n}\n\n.top-header-color-four {\n    background-color: #B3E0A6;\n    border-bottom: 1px solid #ddd;\n  \n}\n\n.genericTable thead tr th:nth-child(1),\n.genericTable tbody tr td:nth-child(1){\n    position: sticky;\n    position: -webkit-sticky;\n    background-color: red;\n    left:0;\n    z-index:2;\n}\n\n\n\n  .table {\n    /* border: 1px solid #ddd; */\n    width: fit-content;\n    /* overflow: scroll;\n    max-width: 100%; */\n\n    .tr {\n      :last-child {\n        .td {\n          border-bottom: 0;\n        }\n      }\n    }\n\n \n\n\n\n\n   .species-table-color-one\n    p {\n      \n      margin-top: 80px;\n     transform: rotate(-45deg);  \n   }\n\n   .species-table-color-two\n   p {\n     \n     margin-top: 80px;\n    transform: rotate(-45deg);  \n  }\n\n  .species-table-color-three\n  p {\n    \n  margin-top: 80px;\n   transform: rotate(-45deg);  \n }\n\n .species-table-color-four\n p {\n   \n   margin-top: 60px;\n   margin-left: 0px;\n   \n  transform: rotate(-45deg);  \n}\n\n.larger, .grey-color, .top-header-grey {\n    background-color: #F7F8F9;\n \n   \n}\n.small-font p{\n    font-size: 12px;\n    padding-top: 2px;\n}\n.larger, .grey-color, .top-header-grey {\nmin-width: 250px;\n}\n\n.small-grey-color {\n    background-color: #F7F8F9;\n    margin-bottom: 1px solid #ddd;\n\n}\n\n\n\n .rowsData{\n    max-height: 50px;\n    \n    }\n\n.top-header-grey, \n.top-header-color-one, \n.top-header-color-two, \n.top-header-color-three, \n.top-header-color-four {\n    max-height: 200px;\n    padding: 5px;\n}\n\n.top-header-grey, \n.top-header-color-one, \n.top-header-color-two, .top-header-color-three, .top-header-color-four p{\n     margin-top: 0px; \n}\n\n .bottom-line {\n    border-bottom: 1px solid #ddd;\n\n} \n\n\n\n .limit-size{\n    max-width: 130px !important;\n} \n    .td {\n      \n       /* border-right: 1px solid #ddd;   */\n      overflow: hidden;  \n\n\n  \n\n\n      .last-element{\n        border-right: 1px solid #ddd;\n    }\n       .resizer {\n        display: inline-block;\n        width: 5px;\n        height: 100%;\n        position: absolute;\n        right: 0;\n        top: 0;\n        transform: translateX(50%);\n        z-index: 1;\n\n        &.isResizing {\n          background: red;\n        }\n      }\n    } \n\n     &.sticky {\n      /* overflow: scroll; */\n      .header,\n      .footer {\n        position: sticky;\n        z-index: 1;\n        width: fit-content;\n      } \n\n      .header {\n        z-index: 4;\n        top: 0;\n        box-shadow: 0px 3px 3px #ccc;\n      }\n\n\n      .body {\n      }\n\n      [data-sticky-td] {\n        position: sticky;\n      }\n\n      [data-sticky-last-left-td] {\n        box-shadow: 2px 0px 3px #ccc;\n      }\n\n      [data-sticky-first-right-td] {\n        box-shadow: -2px 0px 3px #ccc;\n      }\n    }\n  }\n\n  .country-details{\n\n    color: #116AAB;\n    font-size: 1rem;\nfont-style: normal;\nfont-weight: 400;\n\n  }\n\n\n  .country-title{\n\n  \n    font-size: 1rem;\nfont-style: normal;\nfont-weight: 700;\n\n  }\n\n  .csv-button {\n  \n    width: 4.6875rem;\n    height: 2rem;\n    flex-shrink: 0;\n    border-radius: 0.1875rem;\n    background: var(--Primary, #116AAB);\n }\n\n .card-title {\n         font-weight: 500;\n  }\n\n    @media screen and (min-width: 1000px) {\n  .graph-div-main {\n   min-height: 30rem;\n  }\n\n   .graph-div-subquestion {\n   height: 15rem;\n  }\n\n  \n\n}\n\n.container-header {\n    position: relative;\n    height: 4rem\n  }\n\n\n  .big-container-header {\n    position: relative;\n    height: 6rem\n  }\n  .vertical-center {\n  margin: 0 !important;\n  position: absolute !important;\n  top: 50% !important;\n  -ms-transform: translateY(-50%) !important;\n  transform: translateY(-50%)!important;\n \n}\n\n @media screen and (max-width: 1200px) {\n .card-padding {\n  margin-top: 1rem;\n }\n }\n\n  .card-padding-always {\n  margin-top: 2rem;\n }\n\n\n @media screen and (max-width: 600px) {\n .graph-height-mobile {\n  height: 400px !important;\n }\n }\n\n  @media screen and (max-width: 900px) {\n     .col-sm-12 {\n  margin-top:10px !important ;\n }\n\n     .col-xs-12 {\n  margin-top:10px !important;\n }\n }\n\n .full-height {\n  height: 100%;\n  width: 100%;\n }\n\n  @media screen and (min-width: 600px) {\n .mobile-legend {\n  display: none;\n }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
